export default {
  state: {
    step: 0,       // 到哪一步了
    tossupShow: false, // tossup选项框
    tossupAwnseer: false // tossup答案框
  },
  getters: {

  },
  mutations: {
    set_tossupShow (state, val) {
      state.tossupShow = val
    }
  },
  actions: {
    async getApiData (context, val) {
      console.log(val)
      let { commit } = context
      let { state } = context
      console.log(commit, state)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/battle.js